export default __webpack_public_path__ + "static/media/rose6.53b45d36.jpg";